import React, { useEffect, useState, useRef } from "react";

const CurrentTimer = ({ exam, current }) => {
  const [elapsedSeconds, setElapsedSeconds] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!exam || current === undefined) return;

    const key = `current_time_${exam._id}_${current}`;
    const savedStart = localStorage.getItem(key);

    let startTime;

    if (savedStart) {
      startTime = parseInt(savedStart, 10);
    } else {
      startTime = Date.now();
      localStorage.setItem(key, startTime.toString());
    }

    const updateTime = () => {
      const now = Date.now();
      const elapsed = Math.floor((now - startTime) / 1000);
      setElapsedSeconds(elapsed);
    };

    updateTime();
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(updateTime, 1000);

    return () => clearInterval(intervalRef.current);
  }, [exam, current]);

  const formatTime = (seconds) => {
    const m = String(Math.floor(seconds / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");
    return `${m}:${s}`;
  };

  return (
    <>
      <div className="text-base text-black mr-[1rem] sm:mr-[4rem]">
        Thời gian làm câu hiện tại:
      </div>
      <strong className="text-2xl text-[#1c3664] font-mono font-extrabold">
        {formatTime(elapsedSeconds)}
      </strong>
    </>
  );
};

export default CurrentTimer;
